import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "react-router-dom";
import { swalError, swalSuccess } from "@/utils/lib/swal";
import { SubmitButton } from "@/components/ui/button";
import {
  VillagePayloadSchema,
  useVillageCreate,
  villagePayloadSchema,
} from "@/api/village";
import { VillageFormFields } from "./VillageFormFields";
import { FormContainer } from "@/components/form/form-container";
import { Anchor } from "@/components/ui/anchor";
import { ErrorMessageFromResponse } from "@/api/types";

export function VillageCreateForm() {
  const form = useForm<VillagePayloadSchema>({
    resolver: zodResolver(villagePayloadSchema),
  });
  const { mutate, isPending } = useVillageCreate();
  const navigate = useNavigate();

  function handleSubmit(values: VillagePayloadSchema) {
    mutate(
      { data: values },
      {
        onSuccess: () => {
          swalSuccess
            .fire({
              text: "Sub District has been created",
            })
            .then(() => navigate("/master-data/subdistrict"));
        },
        onError: (error) => {
          swalError.fire({
            text:
              (error as ErrorMessageFromResponse).response?.data.data ??
              error.message,
          });
        },
      },
    );
  }

  return (
    <FormContainer form={form} onSubmit={handleSubmit}>
      <VillageFormFields />
      <div className="ml-auto flex gap-x-2">
        <Anchor href="/master-data/subdistrict" mood="axiata-blue-outline">
          Cancel
        </Anchor>
        <SubmitButton loading={isPending} />
      </div>
    </FormContainer>
  );
}
